import React, { useEffect, useState } from 'react';
import db from "../../../../api/mongodb";
import { useNavigate, useParams } from 'react-router-dom';
import { Card, CardContent, CardMedia, Container, Grid, LinearProgress, Typography } from '@mui/material';
import Carousel from 'react-material-ui-carousel'
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const updateBestPracticeObject = (object, propertyAssessmentQuery) => {
    if (object.formData.applicable) {
        for (var i = 0; i < object.formData.applicable.length; i++) {

            object.formData.applicable[i] = capitalizeFirstLetter(object.formData.applicable[i]) + " Level"
        }
    }
    console.log(propertyAssessmentQuery)

    if (object.formData.performance_measure || object.formData.sub_section || object.formData.section) {
        // for
        var copyPerformanceMeasure = object.formData.performance_measure ? [...object.formData.performance_measure] : []
        var copySubsection = object.formData.sub_section ? [...object.formData.sub_section] : []
        var copySection = object.formData.section ? [...object.formData.section] : []
        // console.log(copySection)
        // console.log(copySubsection)
        // console.log(copyPerformanceMeasure)

        for (i = 0; i < propertyAssessmentQuery.data.length; i++) {
            var section = propertyAssessmentQuery.data[i]
            console.log(section['id'])

            if (copySection.indexOf(section['id']) > -1) {
                console.log("hello")
                object.formData.section[copySection.indexOf(section['id'])] = section["name"]
            }



            for (var j = 0; j < section.subsections.length; j++) {
                var subsection = section.subsections[j]

                if (copySubsection.indexOf(subsection['id']) > -1) {
                    // console.log("hello")
                    object.formData.sub_section[copySubsection.indexOf(subsection['id'])] = subsection["name"]
                }
                // if (options.value.includes(subsection.id)) {
                for (var k = 0; k < subsection.performanceMeasure.length; k++) {
                    var performance_measure = subsection.performanceMeasure[k]
                    if (copyPerformanceMeasure.indexOf(performance_measure['id']) > -1) {
                        // console.log("hello")
                        object.formData.performance_measure[copyPerformanceMeasure.indexOf(performance_measure['id'])] = performance_measure["name"]
                    }
                }
                // }

            }
        }
    }



    return object
}


function parseStringForLinks(text) {
    

    // Replace URLs with anchor tags
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const parts = text.split(urlRegex);

    return parts.map((part, index) => {
        if (part.match(urlRegex)) {
            return (
                <a key={index} href={part} target="_blank" rel="noopener noreferrer">
                    {part} <OpenInNewIcon fontSize='10px'/>
                </a>
            );
        }
        return part;
    });

}

const BestPractice = () => {


    const [bestPractice, setBestPractice] = useState({})
    const [isLoading, setIsLoading] = useState(true);
    let { id } = useParams();
    const navigate = useNavigate()


    useEffect(() => {
        if (isLoading) {
            db.get(`/api/propertyAssessments/querySurvey`)
                .then((query) => {
                    db.get(`/api/bestPractices/getOne/${id}`)
                        .then((data) => {

                            console.log(query)

                            setBestPractice(updateBestPracticeObject(data.data, query))
                            setIsLoading(false)
                        })
                        .catch((err) => {
                            // navigate("/projects/active")

                        })
                })

        }
    }, [isLoading])

    console.log(bestPractice)

    return (
        <Container>
            {
                isLoading || JSON.stringify(bestPractice.formData) === JSON.stringify({}) ?
                    "Loading..." :
                    <Card sx={{ marginTop: "20px", marginBottom: "20px" }}>
                        <CardContent>

                            <h2>{bestPractice.formData.name}</h2>

                            <Typography variant='body1'>{bestPractice.formData.description}</Typography>
                            <hr />
                            <Grid container marginTop="20px" rowSpacing={2}>
                                <Grid item xs={6}>

                                    <FieldComponent header="Applicability" data={bestPractice.formData.applicable} isList={Array.isArray(bestPractice.formData.applicable)} />
                                </Grid>
                                <Grid item xs={6}>

                                    <FieldComponent header="Type" data={bestPractice.formData.type} isList={Array.isArray(bestPractice.formData.type)} />

                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    container
                                    direction="column"
                                    alignItems="center"
                                    justifyContent="center">



                                    <h5>Images</h5>


                                    {
                                        typeof bestPractice.formData.images === 'undefined' || bestPractice.formData.images.length === 0 ?
                                            "Nothing to show here..." :
                                            <Carousel
                                                animation='slide'
                                                sx={{ width: "100%" }}
                                                duration={200}
                                                interval={10000}
                                                indicators={false}
                                                navButtonsAlwaysVisible
                                                navButtonsProps={{          // Change the colors and radius of the actual buttons. THIS STYLES BOTH BUTTONS
                                                    style: {
                                                        backgroundColor: 'transparent',
                                                        borderRadius: 0,
                                                        color: "black",
                                                        margin: 0,

                                                    }
                                                }}
                                            >

                                                {
                                                    bestPractice.formData.images.map((photo, i) => {
                                                        console.log(photo['caption'])
                                                        return (<Card variant='outlined' key={i} sx={{
                                                            width: "85%",
                                                            marginLeft: "auto",
                                                            marginRight: 'auto',
                                                            // height: "100px",

                                                        }}>
                                                            <CardMedia
                                                                sx={{ height: "500px" }}
                                                                image={photo.image[0].content}
                                                                title={photo.caption}
                                                            />

                                                            <CardContent>
                                                                {photo['caption']}
                                                            </CardContent>
                                                        </Card>)
                                                    })
                                                }
                                                {/* </React.Fragment> */}
                                            </Carousel>

                                    }
                                </Grid>

                                <Grid item xs={6}>

                                    <FieldComponent header="Sections" data={bestPractice.formData.section} isList={Array.isArray(bestPractice.formData.applicable)} />
                                </Grid>
                                <Grid item xs={6}>

                                    <FieldComponent header="Sub Sections" data={bestPractice.formData.sub_section} isList={Array.isArray(bestPractice.formData.type)} />

                                </Grid>

                                <Grid item xs={12}>

                                    <FieldComponent header="Performance Measures" data={bestPractice.formData.performance_measure} isList={Array.isArray(bestPractice.formData.type)} />

                                </Grid>
                                <Grid item xs={4}>

                                    <FieldComponent header="Property Type" data={bestPractice.formData.property_type} isList={Array.isArray(bestPractice.formData.property_type)} />

                                </Grid>
                                <Grid item xs={4}>

                                    <FieldComponent header="Capital cost implications" data={bestPractice.formData.capital_cost} isList={Array.isArray(bestPractice.formData.capital_cost)} />

                                </Grid>
                                <Grid item xs={4}>

                                    <FieldComponent header="Operating cost implications" data={bestPractice.formData.operating_cost} isList={Array.isArray(bestPractice.formData.operating_cost)} />

                                </Grid>


                                <Grid item xs={4}>

                                    <FieldComponent header="Type of threat" data={bestPractice.formData.threat_type} isList={Array.isArray(bestPractice.formData.threat_type)} />

                                </Grid>
                                <Grid item xs={4}>

                                    <FieldComponent header="Degree of threat" data={bestPractice.formData.threat_degree} isList={Array.isArray(bestPractice.formData.threat_degree)} />

                                </Grid>
                                <Grid item xs={4}>

                                    <FieldComponent header="Threat method" data={bestPractice.formData.threat_method} isList={Array.isArray(bestPractice.formData.threat_method)} />

                                </Grid>
                                <Grid item xs={12}>

                                    <FieldComponent header="Potential suppliers" data={bestPractice.formData.suppliers} isList={Array.isArray(bestPractice.formData.suppliers)} />

                                </Grid>
                                <Grid item xs={12}>

                                    {bestPractice.formData.link ?

                                        <>
                                            <h5>Link to other resources</h5>

                                           
                                                {
                                                    bestPractice.formData.link.split("\n").map((item, i) => {
                                                        // console.log(item)
                                                        return ( <Typography variant='body1' key={i}> {parseStringForLinks(item)}</Typography>)
                                                    })
                                                }
                                            
                                        </>: 
                                        null
                                    }


                                </Grid>

                            </Grid>
                        </CardContent>
                    </Card>
            }
        </Container>
    );
};


const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

const FieldComponent = ({ header, data, isList, isLink }) => {
    return (
        data ?
            <>
                <h5>{header}</h5>

                <Typography variant='body1'>
                    {isList ?
                        data.map((item, i) => {
                            return (<span key={i}>&nbsp;&nbsp;&nbsp;{capitalizeFirstLetter(item)}<br /></span>)
                        }) :
                        capitalizeFirstLetter(data)
                    }
                </Typography>
            </> :
            null
    );
};



export default BestPractice;